import React from 'react';

import PayBillsConfirmationFP from '../FullPagesComponents/Services/Confirmation/PayBillsConfirmationFP';
import { getSubCategoryId } from '../../../utils/DictionaryManagementUtils';
import DiaryImageFP from '../FullPagesComponents/Services/Confirmation/DiaryImageFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================
const PayBillsConfirmationDF = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { confirmation_bill } = globJSON.configurations.services[subCategoryId];
  const isEditDate = confirmation_bill.allow_customer_to_change_payment_date;

  return (
    <SimulatorsViewerArrangement>
      <PayBillsConfirmationFP
        globJSON={globJSON}
        subCategoryId={subCategoryId}
        selectedScreen={selectedScreen}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
      { isEditDate && (
        <DiaryImageFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          language={language}
          slideshowRefs={slideshowRefs}
        />
      )}
    </SimulatorsViewerArrangement>
  );
};

export default PayBillsConfirmationDF;
